
import React from 'react'
import {
  Grid,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
  Box,
} from '@mui/material'
import BlockUi from 'react-block-ui'
import { PacmanLoader } from 'react-spinners'
import { usePlaceAutocomplete } from '@/utils/placeAutocomplete'

/**
 * Property search dialog component for landing page
 * Handles Google Places autocomplete and property search
 */
const PropertySearchDialog = ({
  open,
  onClose,
  onSearch,
  query,
  setQuery,
  placeResult,
  setPlaceResult,
  loading,
}) => {
  usePlaceAutocomplete(
    'autocomplete',
    {
      types: ['geocode'],
      placeholder: 'Search Property',
      onPlaceChanged: (place) => {
        setPlaceResult(place?.address_components ? place : null)
        if (place?.formatted_address) {
          setQuery?.(place.formatted_address)
        }
      },
    },
    open,
  )

  return (
    <Dialog
      open={open}
      onClose={onClose}
      slotProps={{
        paper: { sx: { overflow: 'visible' } },
      }}
    >
      <DialogTitle>Search for a Property</DialogTitle>
      <DialogContent sx={{ p: '1.5rem', overflow: 'visible' }} data-hf="places-dialog-content">
        <BlockUi
          blocking={loading}
          loader={
            <PacmanLoader color={'var(--primary)'} loading={true} />
          }
          message={<Box sx={{ color: '#368cff' }}>Connecting</Box>}
        >
          <DialogContentText>
            Type an address below and we will automatically gather
            data and analyze it for you even if it's not on the MLS!
          </DialogContentText>
          <Grid container direction="row" spacing={1}>
            <Grid size={{ xs: 12, sm: 12 }}>
              <Box data-hf-place-field="" sx={{
                width: "100%",
                position: "relative",
                minHeight: 40,
                marginTop: 0,
                "& > input": { display: "none" },
              }}>
                <input
                  id="autocomplete"
                  type="text"
                  placeholder="Search Property"
                  autoFocus
                  aria-label="Search Property"
                  defaultValue={query || ''}
                />
              </Box>
            </Grid>
          </Grid>
        </BlockUi>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="text">
          Cancel
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={onSearch}
          disabled={!placeResult}
        >
          Search
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default PropertySearchDialog
